import React from 'react'
import View from './view'

const OperationalProfile = ({operational_profile}) => {
  const {
    attributes
  } = operational_profile

  return (
    <div className="details-card">
      <h2>Operational profile</h2>
      <View {...attributes}/>
    </div>
  )
}

export default OperationalProfile


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/operational_profile/index.jsx